import type { StateCreator } from 'zustand'

import type { AppSlice } from '../appSlice'
import type { CapabilitySlice } from '../capabilitySlice'
import type { ChannelSlice } from '../channelSlice'
import type { EditorSlice } from '../editorSlice'
import type { PostSlice } from '../postSlice/postSlice'
import type { SaveErrorsSlice } from '../saveErrorsSlice'

export interface DirtyState {
  /**
   * Ids of legacy drafts (service name, or 'omni') whose content the user has
   * modified during this composer session. Sticky by design: once a draft has
   * held text or an attachment it stays dirty, so validation notices show for
   * drafts the user engaged with — including after they clear the content
   * again — but never for untouched, empty drafts.
   */
  dirtyComposerIds: string[]
}

export interface DirtyActions {
  markComposerDirty: (composerId: string) => void
}

export type DirtySlice = DirtyState & DirtyActions

export const createDirtySlice: StateCreator<
  AppSlice &
    CapabilitySlice &
    ChannelSlice &
    EditorSlice &
    PostSlice &
    SaveErrorsSlice &
    DirtySlice,
  [['zustand/devtools', never], ['zustand/immer', never]],
  [],
  DirtySlice
> = (set) => ({
  dirtyComposerIds: [],

  markComposerDirty: (composerId): void =>
    set(
      (state) => {
        if (!state.dirtyComposerIds.includes(composerId)) {
          state.dirtyComposerIds.push(composerId)
        }
      },
      undefined,
      'dirtySlice:markComposerDirty',
    ),
})
